var map = {
	"./af.json": 3357,
	"./ar.json": 9291,
	"./ca.json": 1928,
	"./cs.json": 9411,
	"./da.json": 8745,
	"./de.json": 9837,
	"./el.json": 5678,
	"./en.json": 6443,
	"./es.json": 5117,
	"./fi.json": 6,
	"./fr.json": 6115,
	"./he.json": 357,
	"./hu.json": 2625,
	"./it.json": 9399,
	"./ja.json": 9078,
	"./ko.json": 6163,
	"./nl.json": 3573,
	"./no.json": 271,
	"./pb.json": 7427,
	"./pl.json": 8130,
	"./pt.json": 5909,
	"./ro.json": 5983,
	"./ru.json": 482,
	"./sl.json": 7485,
	"./sr.json": 9931,
	"./sv.json": 2220,
	"./tr.json": 4596,
	"./uk.json": 7138,
	"./vi.json": 1166,
	"./zh.json": 7554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2149;